import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import classes from "./styles.module.css";
import DateRange from "../../Utils/DateRange";
import { MultipleSelect } from "../../Utils/FieldsHelper";

var STATUSES = [
    { value: 0, label: "Создана", color: "#1565c0" },
    { value: 1, label: "Антифрод", color: "#c62828" },
    { value: 2, label: "Отклонена", color: "#c62828" },
    { value: 7, label: "Ожидает выплаты", color: "#0277bd" },
    { value: 3, label: "Реестр", color: "#7b1fa2" },
    { value: 5, label: "Успех", color: "#2e7d32" },
    { value: 6, label: "Ошибка", color: "#ad1457" },
];

function CrmPayoutFilters(props) {
    var onClose = props.onClose;
    var onApplyFilters = props.onApplyFilters;
    var merchants = props.merchants; // [{uuid, displayName}]
    var isLoading = props.isLoading;

    var _selectedStatuses = useState([]);
    var selectedStatuses = _selectedStatuses[0];
    var setSelectedStatuses = _selectedStatuses[1];

    var _selectedMerchants = useState([]);
    var selectedMerchants = _selectedMerchants[0];
    var setSelectedMerchants = _selectedMerchants[1];

    var _dateRange = useState({});
    var dateRange = _dateRange[0];
    var setDateRange = _dateRange[1];

    var _amountMin = useState("");
    var amountMin = _amountMin[0];
    var setAmountMin = _amountMin[1];

    var _amountMax = useState("");
    var amountMax = _amountMax[0];
    var setAmountMax = _amountMax[1];

    var _targetAmount = useState("");
    var targetAmount = _targetAmount[0];
    var setTargetAmount = _targetAmount[1];

    function handleStatusChange(value, checked) {
        if (checked) {
            setSelectedStatuses(selectedStatuses.concat([value]));
        } else {
            setSelectedStatuses(selectedStatuses.filter(function (s) { return s !== value; }));
        }
    }

    function handleApply() {
        var filters = {};

        if (selectedStatuses.length > 0) {
            filters.status = selectedStatuses;
        }
        if (dateRange && dateRange.startDate) {
            filters.dateFrom = dateRange.startDate;
        }
        if (dateRange && dateRange.endDate) {
            filters.dateTo = dateRange.endDate;
        }
        if (amountMin) {
            filters.amountMin = parseFloat(amountMin);
        }
        if (amountMax) {
            filters.amountMax = parseFloat(amountMax);
        }
        if (targetAmount) {
            filters.targetAmount = parseFloat(targetAmount);
        }

        onApplyFilters({
            filters: filters,
            projects: selectedMerchants.length > 0 ? selectedMerchants : undefined,
        });
        onClose();
    }

    function handleReset() {
        setSelectedStatuses([]);
        setSelectedMerchants([]);
        setDateRange({});
        setAmountMin("");
        setAmountMax("");
        setTargetAmount("");
        onApplyFilters({ filters: {} });
        onClose();
    }

    return (
        <React.Fragment>
            {/* Period */}
            <div className={classes.FilterSection}>
                <div className={classes.FilterLabel}>Период</div>
                <DateRange
                    onSelectDate={function (range) {
                        setDateRange(range || {});
                    }}
                    defaultPeriod={"zero"}
                />
            </div>

            {/* Merchant */}
            <div className={classes.FilterSection}>
                <div className={classes.FilterLabel}>Мерчант</div>
                <MultipleSelect
                    label="Merchant.title"
                    placeholder="Merchant.select"
                    isLoading={false}
                    selectedValues={selectedMerchants}
                    values={merchants || []}
                    onChange={setSelectedMerchants}
                />
            </div>

            {/* Statuses */}
            <div className={classes.FilterSection}>
                <div className={classes.FilterLabel}>Статус</div>
                <div className={classes.StatusList}>
                    {STATUSES.map(function (status) {
                        var isChecked = selectedStatuses.indexOf(status.value) >= 0;
                        return (
                            <label key={status.value} className={classes.StatusCheckbox}>
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={function (e) { handleStatusChange(status.value, e.target.checked); }}
                                />
                                <div
                                    className={classes.StatusDot}
                                    style={{ backgroundColor: status.color }}
                                />
                                <span className={isChecked ? classes.StatusLabelActive : ""}>{status.label}</span>
                            </label>
                        );
                    })}
                </div>
            </div>

            {/* Amount */}
            <div className={classes.FilterSection}>
                <div className={classes.FilterLabel}>Сумма</div>
                <div className={classes.AmountRow}>
                    <input
                        className={classes.AmountInput}
                        type="number"
                        placeholder="от"
                        value={amountMin}
                        onChange={function (e) { setAmountMin(e.target.value); }}
                    />
                    <span className={classes.AmountDash}>&mdash;</span>
                    <input
                        className={classes.AmountInput}
                        type="number"
                        placeholder="до"
                        value={amountMax}
                        onChange={function (e) { setAmountMax(e.target.value); }}
                    />
                </div>
            </div>

            {/* Target amount */}
            <div className={classes.FilterSection}>
                <div className={classes.FilterLabel}>Целевая сумма</div>
                <input
                    className={classes.TargetAmountInput}
                    type="number"
                    placeholder="Целевая сумма"
                    value={targetAmount}
                    onChange={function (e) { setTargetAmount(e.target.value); }}
                    min="0"
                    step="0.01"
                />
                <div className={classes.FilterHint}>
                    Выберите заявки на выплату, ожидающие выплаты, которые совпадают по сумме
                </div>
            </div>

            {/* Buttons */}
            <div className={classes.FilterActions}>
                <button onClick={handleApply} className={classes.ApplyBtn} disabled={isLoading} type="button">
                    <FormattedMessage id="CrmPayout.filters.apply" defaultMessage="Применить" />
                </button>
                <button onClick={handleReset} className={classes.ResetBtn} type="button">
                    <FormattedMessage id="CrmPayout.filters.reset" defaultMessage="Сбросить" />
                </button>
            </div>
        </React.Fragment>
    );
}

CrmPayoutFilters.defaultProps = {
    isOpen: false,
    isLoading: false,
    merchants: [],
    onClose: function () {},
    onApplyFilters: function () {},
};

export default CrmPayoutFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmPayoutFilters/index.js